module.exports = __webpack_public_path__ + "static/media/tick.2026b066.svg";